import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

export default function QrCanvas({ value, size = 220, className = '' }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current || !value) return;
        QRCode.toCanvas(canvasRef.current, value, {
            width: size,
            margin: 1,
            color: { dark: '#09090B', light: '#FFFFFF' },
            errorCorrectionLevel: 'M',
        }).catch(() => { /* noop */ });
    }, [value, size]);

    return <canvas ref={canvasRef} className={className} data-testid="qr-canvas" />;
}
